import { useMemo } from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { buildResponsiveImageSet } from '@honeycomb/ui-core';
import { getHotelImageBaseUrl } from '../../../utils/images';
/**
 * Builds an array of responsive image URLs for a hotel.
 *
 * Given a hotel ID, crop dimensions, and image count, this hook returns
 * an array of {@link ImageSet} objects. Each entry provides URLs for a
 * single hotel image at multiple crop sizes.
 *
 * Returns an empty array if no `estabId` is provided or `imageCount` is zero.
 *
 * @param {UseResponsiveHotelImagesParams} params - Parameters for building hotel image URLs.
 * @returns {Array<ImageSet>} Array of image sets for the requested hotel images.
 */
export const useResponsiveHotelImages = ({ estabId, cropDims, imageCount = 0, }) => {
    const { configSettings: { HotelImageCDN }, } = useGlobalContext();
    return useMemo(() => {
        if (!estabId || imageCount <= 0)
            return [];
        const baseUrl = getHotelImageBaseUrl(HotelImageCDN, estabId);
        return Array.from({ length: imageCount }, (_, i) => buildResponsiveImageSet(`${baseUrl}/${i}`, cropDims, { widthKey: 'width', heightKey: 'height' }, { crop: 'true', quality: 80 }));
    }, [estabId, imageCount, HotelImageCDN, cropDims]);
};
